export default "__VITE_ASSET__2ac46fc7__"